// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".points-possible{margin-top:24px;border-radius:6px;background:#222;color:#fdfdfd}.points-possible>*{margin:4px 0;padding:8px;border-bottom:1px solid #a2a2a2}.points-possible>:last-child{border-bottom:none}.points-possible .text{margin-right:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
